module.exports = __webpack_public_path__ + "media/images/id_background-ec844c578fc15f26d887058280c85e4c.png";